jQuery(function ($) {
  if (typeof profile_data !== "undefined") {
    for (key in profile_data) {
      var $element = $("[name='" + key + "']");
      var value = profile_data[key].trim();

      if (value !== "") {
        if ($element.attr('type') === "radio") {
          $("[name='" + key + "'][value='" + value + "']").prop("checked", true);
        } else if ($element.attr('type') === "checkbox") {
          $("[name='" + key + "'][value='" + value + "']")
            .prop("checked", true)
            .attr("checked", true)
            .parents('label')
            .addClass("active");
        } else {
          $element.val(value).attr("readonly", true);
        }
      }
    }
  }
});


